import React, { useState, useContext } from "react";
import { IoMdCheckmark } from "react-icons/io";
import Equipments from "./Equipments";
import DefaultFee from "./DefaultFee";
import { Stack } from "@mui/material";
import PercentageInput from "./input-elements/PercentageInput";
import CurrencyInput from "./input-elements/CurrencyInput";
import { EquipmentContext } from "../useContext/context";
import { Form } from "react-bootstrap";
import ToggleSwitch from "./input-elements/ToggleSwitch";
import * as Yup from "yup";
import pricingValidation from "../pricing-validation";
import ToggleSwitchContainer from "./input-elements/ToggleSwitchContainer";
import { EMS_OTHER_DEFAULT_FEE } from "../../../../constants";
const tiered_validation = pricingValidation.pricingValidation.tiered;

const validationSchema = Yup.object().shape({
    // Qualified Fields
    tiered_qual_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Qualified Rate is required")
        .min(
            tiered_validation.tiered_qual_rate.minimum,
            `Please enter a rate of ${tiered_validation.tiered_qual_rate.minimum.toFixed(2)}% or higher.`,
        ),

    tiered_qual_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Qualified Transaction Fee is required")
        .min(
            tiered_validation.tiered_qual_transaction.minimum,
            `Please enter a fee of $${tiered_validation.tiered_qual_transaction.minimum.toFixed(2)} or higher.`,
        ),

    tiered_qual_debit_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Qualified Debit Rate is required")
        .min(
            tiered_validation.tiered_qual_debit_rate.minimum,
            `Please enter a rate of ${tiered_validation.tiered_qual_debit_rate.minimum.toFixed(2)}% or higher.`,
        ),

    tiered_qual_debit_per_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Qualified Debit Per Transaction fee is required")
        .min(
            tiered_validation.tiered_qual_debit_per_transaction.minimum,
            `Please enter a fee of $${tiered_validation.tiered_qual_debit_per_transaction.minimum.toFixed(2)} or higher.`,
        ),

    // Mid-Qualified Fields
    tiered_mid_qual_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Mid-Qualified Rate is required")
        .min(
            tiered_validation.tiered_mid_qual_rate.minimum,
            `Please enter a rate of ${tiered_validation.tiered_mid_qual_rate.minimum.toFixed(2)}% or higher.`,
        ),

    tiered_mid_qual_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Mid-Qualified Transaction Fee is required")
        .min(
            tiered_validation.tiered_mid_qual_transaction.minimum,
            `Please enter a fee of $${tiered_validation.tiered_mid_qual_transaction.minimum.toFixed(2)} or higher.`,
        ),

    tiered_mid_qual_debit_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Mid-Qualified Debit Rate is required")
        .min(
            tiered_validation.tiered_mid_qual_debit_rate.minimum,
            `Please enter a rate of ${tiered_validation.tiered_mid_qual_debit_rate.minimum.toFixed(2)}% or higher.`,
        ),

    tiered_mid_qual_debit_per_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Mid-Qualified Debit Per Transaction fee is required")
        .min(
            tiered_validation.tiered_mid_qual_debit_per_transaction.minimum,
            `Please enter a fee of $${tiered_validation.tiered_mid_qual_debit_per_transaction.minimum.toFixed(2)} or higher.`,
        ),

    // Non-Qualified Fields
    tiered_non_qual_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Non-Qualified Rate is required")
        .min(
            tiered_validation.tiered_non_qual_rate.minimum,
            `Please enter a rate of ${tiered_validation.tiered_non_qual_rate.minimum.toFixed(2)}% or higher.`,
        ),

    tiered_non_qual_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Non-Qualified Transaction Fee is required")
        .min(
            tiered_validation.tiered_non_qual_transaction.minimum,
            `Please enter a fee of $${tiered_validation.tiered_non_qual_transaction.minimum.toFixed(2)} or higher.`,
        ),

    tiered_non_qual_debit_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Non-Qualified Debit Rate is required")
        .min(
            tiered_validation.tiered_non_qual_debit_rate.minimum,
            `Please enter a rate of ${tiered_validation.tiered_non_qual_debit_rate.minimum.toFixed(2)}% or higher.`,
        ),

    tiered_non_qual_debit_per_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("Non-Qualified Debit Per Transaction fee is required")
        .min(
            tiered_validation.tiered_non_qual_debit_per_transaction.minimum,
            `Please enter a fee of $${tiered_validation.tiered_non_qual_debit_per_transaction.minimum.toFixed(2)} or higher.`,
        ),

    // Tiered Rate fields
    // AMEX Tier 1
    amex_tier_one_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "tiered",
            then: Yup.number()
                .required("AMEX Tier 1 Rate is required")
                .min(
                    tiered_validation.amex_tier_one_rate.minimum,
                    `Please enter a rate of ${tiered_validation.amex_tier_one_rate.minimum.toFixed(2)}% or higher.`,
                ),
            otherwise: Yup.number().notRequired(),
        }),
    amex_tier_one_fee: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "tiered",
            then: Yup.number()
                .required("AMEX Tier 1 Fee is required")
                .min(
                    tiered_validation.amex_tier_one_fee.minimum,
                    `Please enter a fee of $${tiered_validation.amex_tier_one_fee.minimum.toFixed(2)} or higher.`,
                ),
            otherwise: Yup.number().notRequired(),
        }),

    // AMEX Tier 2
    amex_tier_two_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "tiered",
            then: Yup.number()
                .required("AMEX Tier 2 Rate is required")
                .min(
                    tiered_validation.amex_tier_two_rate.minimum,
                    `Please enter a rate of ${tiered_validation.amex_tier_two_rate.minimum.toFixed(2)}% or higher.`,
                ),
            otherwise: Yup.number().notRequired(),
        }),
    amex_tier_two_fee: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "tiered",
            then: Yup.number()
                .required("AMEX Tier 2 Fee is required")
                .min(
                    tiered_validation.amex_tier_two_fee.minimum,
                    `Please enter a fee of $${tiered_validation.amex_tier_two_fee.minimum.toFixed(2)} or higher.`,
                ),
            otherwise: Yup.number().notRequired(),
        }),

    // AMEX Tier 3
    amex_tier_three_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "tiered",
            then: Yup.number()
                .required("AMEX Tier 3 Rate is required")
                .min(
                    tiered_validation.amex_tier_three_rate.minimum,
                    `Please enter a rate of ${tiered_validation.amex_tier_three_rate.minimum.toFixed(2)}% or higher.`,
                ),
            otherwise: Yup.number().notRequired(),
        }),
    amex_tier_three_fee: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "tiered",
            then: Yup.number()
                .required("AMEX Tier 3 Fee is required")
                .min(
                    tiered_validation.amex_tier_three_fee.minimum,
                    `Please enter a fee of $${tiered_validation.amex_tier_three_fee.minimum.toFixed(2)} or higher.`,
                ),
            otherwise: Yup.number().notRequired(),
        }),

    // AMEX Tier 4
    amex_tier_four_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "tiered",
            then: Yup.number()
                .required("AMEX Tier 4 Rate is required")
                .min(
                    tiered_validation.amex_tier_four_rate.minimum,
                    `Please enter a rate of ${tiered_validation.amex_tier_four_rate.minimum.toFixed(2)}% or higher.`,
                ),
            otherwise: Yup.number().notRequired(),
        }),
    amex_tier_four_fee: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "tiered",
            then: Yup.number()
                .required("AMEX Tier 4 Fee is required")
                .min(
                    tiered_validation.amex_tier_four_fee.minimum,
                    `Please enter a fee of $${tiered_validation.amex_tier_four_fee.minimum.toFixed(2)} or higher.`,
                ),
            otherwise: Yup.number().notRequired(),
        }),

    // AMEX Flat Rate
    tiered_amex_flat_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "flat_rate",
            then: Yup.number()
                .required("AMEX Flat Rate is required")
                .min(
                    tiered_validation.tiered_amex_flat_rate.minimum,
                    `Please enter a rate of ${tiered_validation.tiered_amex_flat_rate.minimum.toFixed(2)}% or higher.`,
                ),
            otherwise: Yup.number(),
        }),

    tiered_amex_flat_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "flat_rate",
            then: Yup.number()
                .required("AMEX Flat Transaction Fee is required")
                .min(
                    tiered_validation.tiered_amex_flat_transaction.minimum,
                    `Please enter a fee of $${tiered_validation.tiered_amex_flat_transaction.minimum.toFixed(2)} or higher.`,
                ),
            otherwise: Yup.number(),
        }),

    // AMEX Interchange Plus
    tiered_amex_ic_plus_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "ic_plus",
            then: Yup.number()
                .required("AMEX IC+ Rate is required")
                .min(
                    tiered_validation.tiered_amex_ic_plus_rate.minimum,
                    `Please enter a rate of ${tiered_validation.tiered_amex_ic_plus_rate.minimum.toFixed(2)}% or higher.`,
                ),
            otherwise: Yup.number(),
        }),

    tiered_amex_ic_plus_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("pricing_model", {
            is: "ic_plus",
            then: Yup.number()
                .required("AMEX IC+ Transaction Fee is required")
                .min(
                    tiered_validation.tiered_amex_ic_plus_transaction.minimum,
                    `Please enter a fee of $${tiered_validation.tiered_amex_ic_plus_transaction.minimum.toFixed(2)} or higher.`,
                ),
            otherwise: Yup.number(),
        }),

    tiered_pin_debit_rate: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("PIN-based Debit Rate is required")
        .min(
            tiered_validation.tiered_pin_debit_rate.minimum,
            `Please enter a rate of ${tiered_validation.tiered_pin_debit_rate.minimum.toFixed(2)}% or higher.`,
        ),

    tiered_pin_debit_per_transaction: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .required("PIN-based Debit Per Transaction fee is required")
        .min(
            tiered_validation.tiered_pin_debit_per_transaction.minimum,
            `Please enter a fee of $${tiered_validation.tiered_pin_debit_per_transaction.minimum.toFixed(2)} or higher.`,
        ),

    tiered_pin_debit_network_fee: Yup.string().required(
        "Network Fee selection is required",
    ),

    fnf_number: Yup.number()
        .transform((value, originalValue) => (originalValue === "" ? 0 : value))
        .when("ebt", {
            is: "yes",
            then: Yup.number().required("FNF Number is Required"),
            otherwise: Yup.number(),
        }),
});

const TieredPricing = ({
    selectedEquipments,
    emsEquipments,
    setFormDataByKeyValue,
    errors,
    form_data,
    allEquipments,
    removeError: removeErrorEq,
}) => {
    const [selectedRate, setSelectedRate] = useState("3");
    const { setErrors } = useContext(EquipmentContext);

    const handleOnChange = (e) => {
        try {
            e?.persist();
        } catch (error) {}
        const updatedFormData = {
            ...form_data,
            [e.target.name]: e.target.value,
        };

        setFormDataByKeyValue(e.target.name, e.target.value);
        validationSchema
            .validateAt(e.target.name, updatedFormData)
            .then((e) => {
                // nothing here
            })
            .catch((err) => {
                let validation_errors = errors;
                validation_errors = {
                    ...validation_errors,
                    [e.target.name]: err.errors,
                };
                setErrors(validation_errors);
            });
    };

    return (
        <div className="dual-pricing-section tiered-pricing">
            <div className="container-col-2">
                <div className="top-label-box">
                    <div className="top-label">
                        <span>Qualified</span>
                        <img src="/images/visa.png" />
                        <img src="/images/mastercard.png" />
                        <img src="/images/discover.png" />
                    </div>
                    <div className="top-label-box-content">
                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            className="container-col-2"
                        >
                            <div className="w-100">
                                <PercentageInput
                                    label="Qual Rate"
                                    placeholder="0.00"
                                    name={"tiered_qual_rate"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_qual_rate}
                                    errors={errors}
                                />
                                {errors?.tiered_qual_rate &&
                                    Array.isArray(errors.tiered_qual_rate) &&
                                    errors.tiered_qual_rate.map((error) => (
                                        <span className="error-message">
                                            {error}
                                        </span>
                                    ))}
                            </div>
                            <div className="w-100">
                                <CurrencyInput
                                    label="Txn Fee"
                                    placeholder="0.10"
                                    name={"tiered_qual_transaction"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_qual_transaction}
                                    errors={errors}
                                />
                                {errors?.tiered_qual_transaction &&
                                    Array.isArray(
                                        errors.tiered_qual_transaction,
                                    ) &&
                                    errors.tiered_qual_transaction.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                            <div className="w-100">
                                <PercentageInput
                                    label="Debit Rate"
                                    placeholder="0.00"
                                    name={"tiered_qual_debit_rate"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_qual_debit_rate}
                                    errors={errors}
                                />
                                {errors?.tiered_qual_debit_rate &&
                                    Array.isArray(
                                        errors.tiered_qual_debit_rate,
                                    ) &&
                                    errors.tiered_qual_debit_rate.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                            <div className="w-100">
                                <CurrencyInput
                                    label="Debit Per Txn"
                                    placeholder="0.10"
                                    name={"tiered_qual_debit_per_transaction"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={
                                        form_data.tiered_qual_debit_per_transaction
                                    }
                                    errors={errors}
                                />
                                {errors?.tiered_qual_debit_per_transaction &&
                                    Array.isArray(
                                        errors.tiered_qual_debit_per_transaction,
                                    ) &&
                                    errors.tiered_qual_debit_per_transaction.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                        </Stack>
                    </div>
                </div>
            </div>

            <div className="container-col-2">
                <div className="top-label-box">
                    <div className="top-label">
                        <span>Mid-Qualified</span>
                        <img src="/images/visa.png" />
                        <img src="/images/mastercard.png" />
                        <img src="/images/discover.png" />
                    </div>
                    <div className="top-label-box-content">
                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            className="container-col-2"
                        >
                            <div className="w-100">
                                <PercentageInput
                                    label="Mid-Qual Rate"
                                    placeholder="0.00"
                                    name={"tiered_mid_qual_rate"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_mid_qual_rate}
                                    errors={errors}
                                />
                                {errors?.tiered_mid_qual_rate &&
                                    Array.isArray(
                                        errors.tiered_mid_qual_rate,
                                    ) &&
                                    errors.tiered_mid_qual_rate.map((error) => (
                                        <span className="error-message">
                                            {error}
                                        </span>
                                    ))}
                            </div>
                            <div className="w-100">
                                <CurrencyInput
                                    label="Txn Fee"
                                    placeholder="0.10"
                                    name={"tiered_mid_qual_transaction"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={
                                        form_data.tiered_mid_qual_transaction
                                    }
                                    errors={errors}
                                />
                                {errors?.tiered_mid_qual_transaction &&
                                    Array.isArray(
                                        errors.tiered_mid_qual_transaction,
                                    ) &&
                                    errors.tiered_mid_qual_transaction.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                            <div className="w-100">
                                <PercentageInput
                                    label="Debit Rate"
                                    placeholder="0.00"
                                    name={"tiered_mid_qual_debit_rate"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_mid_qual_debit_rate}
                                    errors={errors}
                                />
                                {errors?.tiered_mid_qual_debit_rate &&
                                    Array.isArray(
                                        errors.tiered_mid_qual_debit_rate,
                                    ) &&
                                    errors.tiered_mid_qual_debit_rate.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                            <div className="w-100">
                                <CurrencyInput
                                    label="Debit Per Txn"
                                    placeholder="0.10"
                                    name={
                                        "tiered_mid_qual_debit_per_transaction"
                                    }
                                    type="number"
                                    onChange={handleOnChange}
                                    value={
                                        form_data.tiered_mid_qual_debit_per_transaction
                                    }
                                    errors={errors}
                                />
                                {errors?.tiered_mid_qual_debit_per_transaction &&
                                    Array.isArray(
                                        errors.tiered_mid_qual_debit_per_transaction,
                                    ) &&
                                    errors.tiered_mid_qual_debit_per_transaction.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                        </Stack>
                    </div>
                </div>
            </div>

            <div className="container-col-2">
                <div className="top-label-box">
                    <div className="top-label">
                        <span>Non-Qualified</span>
                        <img src="/images/visa.png" />
                        <img src="/images/mastercard.png" />
                        <img src="/images/discover.png" />
                    </div>
                    <div className="top-label-box-content">
                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            className="container-col-2"
                        >
                            <div className="w-100">
                                <PercentageInput
                                    label="Non-Qual Rate"
                                    placeholder="0.00"
                                    name={"tiered_non_qual_rate"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_non_qual_rate}
                                    errors={errors}
                                />
                                {errors?.tiered_non_qual_rate &&
                                    Array.isArray(
                                        errors.tiered_non_qual_rate,
                                    ) &&
                                    errors.tiered_non_qual_rate.map((error) => (
                                        <span className="error-message">
                                            {error}
                                        </span>
                                    ))}
                            </div>
                            <div className="w-100">
                                <CurrencyInput
                                    label="Txn Fee"
                                    placeholder="0.10"
                                    name={"tiered_non_qual_transaction"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={
                                        form_data.tiered_non_qual_transaction
                                    }
                                    errors={errors}
                                />
                                {errors?.tiered_non_qual_transaction &&
                                    Array.isArray(
                                        errors.tiered_non_qual_transaction,
                                    ) &&
                                    errors.tiered_non_qual_transaction.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                            <div className="w-100">
                                <PercentageInput
                                    label="Debit Rate"
                                    placeholder="0.00"
                                    name={"tiered_non_qual_debit_rate"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_non_qual_debit_rate}
                                    errors={errors}
                                />
                                {errors?.tiered_non_qual_debit_rate &&
                                    Array.isArray(
                                        errors.tiered_non_qual_debit_rate,
                                    ) &&
                                    errors.tiered_non_qual_debit_rate.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                            <div className="w-100">
                                <CurrencyInput
                                    label="Debit Per Txn"
                                    placeholder="0.10"
                                    name={
                                        "tiered_non_qual_debit_per_transaction"
                                    }
                                    type="number"
                                    onChange={handleOnChange}
                                    value={
                                        form_data.tiered_non_qual_debit_per_transaction
                                    }
                                    errors={errors}
                                />
                                {errors?.tiered_non_qual_debit_per_transaction &&
                                    Array.isArray(
                                        errors.tiered_non_qual_debit_per_transaction,
                                    ) &&
                                    errors.tiered_non_qual_debit_per_transaction.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                        </Stack>
                    </div>
                </div>
            </div>

            <div className="equipment-box mt-2r">
                <p className="box-label">PIN-based Debit</p>
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    className="container-col-2 mb-1r mt-2r"
                >
                    <div className="w-60">
                        <ToggleSwitchContainer
                            handleChange={(_e, value) =>
                                setFormDataByKeyValue(
                                    "tiered_pin_debit_network_fee",
                                    value,
                                )
                            }
                            value={form_data.tiered_pin_debit_network_fee}
                            options={[
                                { key: "yes", value: "Yes" },
                                { key: "no", value: "No" },
                            ]}
                            name="tiered_pin_debit_network_fee"
                            label="Network Fee"
                        />
                        {errors?.tiered_pin_debit_network_fee &&
                            Array.isArray(
                                errors.tiered_pin_debit_network_fee,
                            ) &&
                            errors.tiered_pin_debit_network_fee.map((error) => (
                                <span className="error-message">{error}</span>
                            ))}
                    </div>
                    <div className="w-100">
                        <PercentageInput
                            label="Debit Rate"
                            type="number"
                            placeholder="0.5"
                            name={"tiered_pin_debit_rate"}
                            onChange={handleOnChange}
                            value={form_data.tiered_pin_debit_rate}
                            errors={errors}
                        />
                        {errors?.tiered_pin_debit_rate &&
                            Array.isArray(errors.tiered_pin_debit_rate) &&
                            errors.tiered_pin_debit_rate.map((error) => (
                                <span className="error-message">{error}</span>
                            ))}
                    </div>
                    <div className="w-100">
                        <CurrencyInput
                            label="Per Txn"
                            type="number"
                            placeholder="0.15"
                            name={"tiered_pin_debit_per_transaction"}
                            onChange={handleOnChange}
                            value={form_data.tiered_pin_debit_per_transaction}
                            errors={errors}
                        />
                        {errors?.tiered_pin_debit_per_transaction &&
                            Array.isArray(
                                errors.tiered_pin_debit_per_transaction,
                            ) &&
                            errors.tiered_pin_debit_per_transaction.map(
                                (error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ),
                            )}
                    </div>
                </Stack>
            </div>

            <div className="equipment-box mt-4r ebt-transaction">
                <p className="box-label">EBT Transactions</p>
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    className="container-col-2 mb-1r mt-2r"
                >
                    <div className="ebt-switch">
                        <ToggleSwitchContainer
                            handleChange={(_e, value) =>
                                setFormDataByKeyValue("ebt", value)
                            }
                            value={form_data.ebt}
                            options={[
                                { key: "yes", value: "Yes" },
                                { key: "no", value: "No" },
                            ]}
                            name="ebt"
                            label="EBT"
                        />
                        {errors?.ebt &&
                            Array.isArray(errors.ebt) &&
                            errors.ebt.map((error) => (
                                <span className="error-message">{error}</span>
                            ))}
                    </div>
                    {form_data.ebt == "yes" && (
                        <div className="d-flex w-100">
                            <div className="floating-form w-100">
                                <Form.Group size="lg" controlId="fnf_number">
                                    <Form.Control
                                        placeholder="FNS Number"
                                        type="text"
                                        name="fnf_number"
                                        value={form_data.fnf_number}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) {
                                                handleOnChange(e);
                                            }
                                        }}
                                        className="input-control"
                                        maxLength={7}
                                    />
                                    <Form.Label className="floating-label">
                                        FNF Number
                                    </Form.Label>
                                </Form.Group>
                                {errors?.fnf_number &&
                                    Array.isArray(errors.fnf_number) &&
                                    errors.fnf_number.map((error) => (
                                        <span className="error-message">
                                            {error}
                                        </span>
                                    ))}
                            </div>
                            <div className="floating-form w-100">
                                <CurrencyInput
                                    label="EBT Transactions"
                                    endAdornment="/txn"
                                    placeholder={
                                        EMS_OTHER_DEFAULT_FEE.ebt_transactions
                                    }
                                    value={form_data.ebt_transactions}
                                    name={"ebt_transactions"}
                                    type="number"
                                    onChange={handleOnChange}
                                    errors={errors}
                                />
                                {errors?.ebt_transactions &&
                                    Array.isArray(errors.ebt_transactions) &&
                                    errors.ebt_transactions.map((error) => (
                                        <span className="error-message">
                                            {error}
                                        </span>
                                    ))}
                            </div>
                        </div>
                    )}
                </Stack>
            </div>

            <p className="sub-heading-lead mt-4r">
                Select your preferred AMEX structure
            </p>
            <div className="pricing-model-buttons ">
                <button
                    type="button"
                    className={
                        form_data.pricing_model == "flat_rate" ? "active" : ""
                    }
                    onClick={() =>
                        setFormDataByKeyValue("pricing_model", "flat_rate")
                    }
                >
                    {form_data.pricing_model == "flat_rate" ? (
                        <IoMdCheckmark />
                    ) : (
                        ""
                    )}{" "}
                    Flat Rate
                </button>
                <button
                    type="button"
                    className={
                        form_data.pricing_model == "tiered" ? "active" : ""
                    }
                    onClick={() =>
                        setFormDataByKeyValue("pricing_model", "tiered")
                    }
                >
                    {form_data.pricing_model == "tiered" ? (
                        <IoMdCheckmark />
                    ) : (
                        ""
                    )}{" "}
                    Tiered Rate
                </button>
                <button
                    type="button"
                    className={
                        form_data.pricing_model == "ic_plus" ? "active" : ""
                    }
                    onClick={() =>
                        setFormDataByKeyValue("pricing_model", "ic_plus")
                    }
                >
                    {form_data.pricing_model == "ic_plus" ? (
                        <IoMdCheckmark />
                    ) : (
                        ""
                    )}{" "}
                    IC+
                </button>
            </div>

            {form_data.pricing_model == "tiered" && (
                <>
                    <div className="top-label-box">
                        <div className="top-label">
                            <span>AMEX Tier 1</span>
                            <img src="/images/amex.png" />
                        </div>
                        <div className="top-label-box-content">
                            <div className="container-col-2">
                                <div className="w-100">
                                    <PercentageInput
                                        label="Rate"
                                        placeholder="0.00"
                                        name={"amex_tier_one_rate"}
                                        type="number"
                                        onChange={handleOnChange}
                                        value={form_data.amex_tier_one_rate}
                                        errors={errors}
                                    />
                                    {errors?.amex_tier_one_rate &&
                                        Array.isArray(
                                            errors.amex_tier_one_rate,
                                        ) &&
                                        errors.amex_tier_one_rate.map(
                                            (error) => (
                                                <span className="error-message">
                                                    {error}
                                                </span>
                                            ),
                                        )}
                                </div>
                                <div className="w-100">
                                    <CurrencyInput
                                        label="Txn Fee"
                                        placeholder="0.10"
                                        name={"amex_tier_one_fee"}
                                        type="number"
                                        onChange={handleOnChange}
                                        value={form_data.amex_tier_one_fee}
                                        errors={errors}
                                    />
                                    {errors?.amex_tier_one_fee &&
                                        Array.isArray(
                                            errors.amex_tier_one_fee,
                                        ) &&
                                        errors.amex_tier_one_fee.map(
                                            (error) => (
                                                <span className="error-message">
                                                    {error}
                                                </span>
                                            ),
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="top-label-box">
                        <div className="top-label">
                            <span>AMEX Tier 2</span>
                            <img src="/images/amex.png" />
                        </div>
                        <div className="top-label-box-content">
                            <div className="container-col-2">
                                <div className="w-100">
                                    <PercentageInput
                                        label="Rate"
                                        placeholder="0.00"
                                        name={"amex_tier_two_rate"}
                                        type="number"
                                        onChange={handleOnChange}
                                        value={form_data.amex_tier_two_rate}
                                        errors={errors}
                                    />
                                    {errors?.amex_tier_two_rate &&
                                        Array.isArray(
                                            errors.amex_tier_two_rate,
                                        ) &&
                                        errors.amex_tier_two_rate.map(
                                            (error) => (
                                                <span className="error-message">
                                                    {error}
                                                </span>
                                            ),
                                        )}
                                </div>
                                <div className="w-100">
                                    <CurrencyInput
                                        label="Txn Fee"
                                        placeholder="0.10"
                                        name={"amex_tier_two_fee"}
                                        type="number"
                                        onChange={handleOnChange}
                                        value={form_data.amex_tier_two_fee}
                                        errors={errors}
                                    />
                                    {errors?.amex_tier_two_fee &&
                                        Array.isArray(
                                            errors.amex_tier_two_fee,
                                        ) &&
                                        errors.amex_tier_two_fee.map(
                                            (error) => (
                                                <span className="error-message">
                                                    {error}
                                                </span>
                                            ),
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="top-label-box">
                        <div className="top-label">
                            <span>AMEX Tier 3</span>
                            <img src="/images/amex.png" />
                        </div>
                        <div className="top-label-box-content">
                            <div className="container-col-2">
                                <div className="w-100">
                                    <PercentageInput
                                        label="Rate"
                                        placeholder="0.00"
                                        name={"amex_tier_three_rate"}
                                        type="number"
                                        onChange={handleOnChange}
                                        value={form_data.amex_tier_three_rate}
                                        errors={errors}
                                    />
                                    {errors?.amex_tier_three_rate &&
                                        Array.isArray(
                                            errors.amex_tier_three_rate,
                                        ) &&
                                        errors.amex_tier_three_rate.map(
                                            (error) => (
                                                <span className="error-message">
                                                    {error}
                                                </span>
                                            ),
                                        )}
                                </div>
                                <div className="w-100">
                                    <CurrencyInput
                                        label="Txn Fee"
                                        placeholder="0.10"
                                        name={"amex_tier_three_fee"}
                                        type="number"
                                        onChange={handleOnChange}
                                        value={form_data.amex_tier_three_fee}
                                        errors={errors}
                                    />
                                    {errors?.amex_tier_three_fee &&
                                        Array.isArray(
                                            errors.amex_tier_three_fee,
                                        ) &&
                                        errors.amex_tier_three_fee.map(
                                            (error) => (
                                                <span className="error-message">
                                                    {error}
                                                </span>
                                            ),
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="top-label-box">
                        <div className="top-label">
                            <span>AMEX Tier 4</span>
                            <img src="/images/amex.png" />
                        </div>
                        <div className="top-label-box-content">
                            <div className="container-col-2">
                                <div className="w-100">
                                    <PercentageInput
                                        label="Rate"
                                        placeholder="0.00"
                                        name={"amex_tier_four_rate"}
                                        type="number"
                                        onChange={handleOnChange}
                                        value={form_data.amex_tier_four_rate}
                                        errors={errors}
                                    />
                                    {errors?.amex_tier_four_rate &&
                                        Array.isArray(
                                            errors.amex_tier_four_rate,
                                        ) &&
                                        errors.amex_tier_four_rate.map(
                                            (error) => (
                                                <span className="error-message">
                                                    {error}
                                                </span>
                                            ),
                                        )}
                                </div>
                                <div className="w-100">
                                    <CurrencyInput
                                        label="Txn Fee"
                                        placeholder="0.10"
                                        name={"amex_tier_four_fee"}
                                        type="number"
                                        onChange={handleOnChange}
                                        value={form_data.amex_tier_four_fee}
                                        errors={errors}
                                    />
                                    {errors?.amex_tier_four_fee &&
                                        Array.isArray(
                                            errors.amex_tier_four_fee,
                                        ) &&
                                        errors.amex_tier_four_fee.map(
                                            (error) => (
                                                <span className="error-message">
                                                    {error}
                                                </span>
                                            ),
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {form_data.pricing_model == "flat_rate" && (
                <div className="top-label-box">
                    <div className="top-label">
                        <span>AMEX Flat Rate</span>
                        <img src="/images/amex.png" />
                    </div>
                    <div className="top-label-box-content">
                        <div className="container-col-2">
                            <div className="w-100">
                                <CurrencyInput
                                    label="Flat Rate"
                                    placeholder="0.10"
                                    name={"tiered_amex_flat_rate"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_amex_flat_rate}
                                    errors={errors}
                                />
                                {errors?.tiered_amex_flat_rate &&
                                    Array.isArray(
                                        errors.tiered_amex_flat_rate,
                                    ) &&
                                    errors.tiered_amex_flat_rate.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                            <div className="w-100">
                                <CurrencyInput
                                    label="Txn Fee"
                                    placeholder="0.10"
                                    name={"tiered_amex_flat_transaction"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={
                                        form_data.tiered_amex_flat_transaction
                                    }
                                    errors={errors}
                                />
                                {errors?.tiered_amex_flat_transaction &&
                                    Array.isArray(
                                        errors.tiered_amex_flat_transaction,
                                    ) &&
                                    errors.tiered_amex_flat_transaction.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {form_data.pricing_model == "ic_plus" && (
                <div className="top-label-box">
                    <div className="top-label">
                        <span>AMEX Interchange Plus</span>
                        <img src="/images/amex.png" />
                    </div>
                    <div className="top-label-box-content">
                        <div className="container-col-2">
                            <div className="w-100">
                                <PercentageInput
                                    label="IC+ Rate"
                                    placeholder="0.10"
                                    name={"tiered_amex_ic_plus_rate"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={form_data.tiered_amex_ic_plus_rate}
                                    errors={errors}
                                />
                                {errors?.tiered_amex_ic_plus_rate &&
                                    Array.isArray(
                                        errors.tiered_amex_ic_plus_rate,
                                    ) &&
                                    errors.tiered_amex_ic_plus_rate.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                            <div className="w-100">
                                <CurrencyInput
                                    label="Txn Fee"
                                    placeholder="0.10"
                                    name={"tiered_amex_ic_plus_transaction"}
                                    type="number"
                                    onChange={handleOnChange}
                                    value={
                                        form_data.tiered_amex_ic_plus_transaction
                                    }
                                    errors={errors}
                                />
                                {errors?.tiered_amex_ic_plus_transaction &&
                                    Array.isArray(
                                        errors.tiered_amex_ic_plus_transaction,
                                    ) &&
                                    errors.tiered_amex_ic_plus_transaction.map(
                                        (error) => (
                                            <span className="error-message">
                                                {error}
                                            </span>
                                        ),
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <DefaultFee
                form_data={form_data}
                setFormDataByKeyValue={setFormDataByKeyValue}
                errors={errors}
            />

            {selectedRate && (
                <Equipments
                    selectedEquipments={selectedEquipments}
                    emsEquipments={emsEquipments}
                    setFormDataByKeyValue={setFormDataByKeyValue}
                    form_data={form_data}
                    errors={errors}
                    allEquipments={allEquipments}
                    removeError={removeErrorEq}
                />
            )}
        </div>
    );
};

export default TieredPricing;
